import React from 'react';

import cx from 'classnames';

import { getCurrentLogoByLocale } from '@shared/helpers';

import s from './Header.module.css';
import { BackStepItem } from '../BackStep/BackStepItem';

export const Header = ({ type, link, backLogin, needShowBack }) => {
    const currentLogo = getCurrentLogoByLocale(LOCALE);

    return (
        <header
            className={cx(s.formHeader, {
                [s.desktopHeader]: type === 'desktop',
                [s.mobileHeader]: type === 'mobile',
            })}
        >
            <a href={BASE_URL} className={s.logo}>
                <img src={currentLogo} alt="main logo" />
            </a>
            {link && !backLogin && needShowBack && link}
            {!link && !backLogin && needShowBack && (
                <div className={s.stepBackDesktop}>
                    <a href={BASE_URL}>
                        <BackStepItem text={i18next.t('Header.return.backToSite')} />
                    </a>
                </div>
            )}
            {backLogin && needShowBack && (
                <div className={s.stepBackDesktop}>
                    <a href={`${BASE_URL}/login`}>
                        <BackStepItem text={i18next.t('Header.return.back')} />
                    </a>
                </div>
            )}
        </header>
    );
};
